// Locally generated dummy dataset for the Forecast Engine demo — 24 months of
// history plus a 6-month forward forecast (with confidence band) per SKU, built
// with seasonality, an underlying growth trend, and periodic promo spikes so the
// charts read like a real K-beauty inventory forecasting tool.

export const skuForecasts = {
  'GLW-SER-30': {
    sku: 'GLW-SER-30',
    name: 'Glow Serum 30ml',
    unitPrice: 28,
    currentStock: 984,
    daysCover: 48,
    status: 'HEALTHY',
    reorderQty: 0,
    nextMonthForecast: 630,
    mape: 6.4,
    yoyGrowth: 11.9,
    rows: [
      { month: 'Jul 24', actual: 479, forecast: null, lower: null, upper: null },
      { month: 'Aug 24', actual: 494, forecast: null, lower: null, upper: null },
      { month: 'Sep 24', actual: 497, forecast: null, lower: null, upper: null },
      { month: 'Oct 24', actual: 481, forecast: null, lower: null, upper: null },
      { month: 'Nov 24', actual: 617, forecast: null, lower: null, upper: null },
      { month: 'Dec 24', actual: 431, forecast: null, lower: null, upper: null },
      { month: 'Jan 25', actual: 393, forecast: null, lower: null, upper: null },
      { month: 'Feb 25', actual: 414, forecast: null, lower: null, upper: null },
      { month: 'Mar 25', actual: 432, forecast: null, lower: null, upper: null },
      { month: 'Apr 25', actual: 453, forecast: null, lower: null, upper: null },
      { month: 'May 25', actual: 638, forecast: null, lower: null, upper: null },
      { month: 'Jun 25', actual: 545, forecast: null, lower: null, upper: null },
      { month: 'Jul 25', actual: 552, forecast: null, lower: null, upper: null },
      { month: 'Aug 25', actual: 580, forecast: null, lower: null, upper: null },
      { month: 'Sep 25', actual: 579, forecast: null, lower: null, upper: null },
      { month: 'Oct 25', actual: 537, forecast: null, lower: null, upper: null },
      { month: 'Nov 25', actual: 661, forecast: null, lower: null, upper: null },
      { month: 'Dec 25', actual: 496, forecast: null, lower: null, upper: null },
      { month: 'Jan 26', actual: 486, forecast: null, lower: null, upper: null },
      { month: 'Feb 26', actual: 484, forecast: null, lower: null, upper: null },
      { month: 'Mar 26', actual: 509, forecast: null, lower: null, upper: null },
      { month: 'Apr 26', actual: 514, forecast: null, lower: null, upper: null },
      { month: 'May 26', actual: 721, forecast: null, lower: null, upper: null },
      { month: 'Jun 26', actual: 610, forecast: 610, lower: 610, upper: 610 },
      { month: 'Jul 26', actual: null, forecast: 630, lower: 570, upper: 690 },
      { month: 'Aug 26', actual: null, forecast: 666, lower: 593, upper: 739 },
      { month: 'Sep 26', actual: null, forecast: 663, lower: 580, upper: 746 },
      { month: 'Oct 26', actual: null, forecast: 792, lower: 681, upper: 903 },
      { month: 'Nov 26', actual: null, forecast: 599, lower: 506, upper: 692 },
      { month: 'Dec 26', actual: null, forecast: 591, lower: 491, upper: 691 },
    ],
  },
  'SNL-MUC-50': {
    sku: 'SNL-MUC-50',
    name: 'Snail Mucin Essence 50ml',
    unitPrice: 34,
    currentStock: 1258,
    daysCover: 39,
    status: 'HEALTHY',
    reorderQty: 0,
    nextMonthForecast: 850,
    mape: 7.1,
    yoyGrowth: 16.8,
    rows: [
      { month: 'Jul 24', actual: 673, forecast: null, lower: null, upper: null },
      { month: 'Aug 24', actual: 610, forecast: null, lower: null, upper: null },
      { month: 'Sep 24', actual: 573, forecast: null, lower: null, upper: null },
      { month: 'Oct 24', actual: 762, forecast: null, lower: null, upper: null },
      { month: 'Nov 24', actual: 557, forecast: null, lower: null, upper: null },
      { month: 'Dec 24', actual: 615, forecast: null, lower: null, upper: null },
      { month: 'Jan 25', actual: 626, forecast: null, lower: null, upper: null },
      { month: 'Feb 25', actual: 696, forecast: null, lower: null, upper: null },
      { month: 'Mar 25', actual: 755, forecast: null, lower: null, upper: null },
      { month: 'Apr 25', actual: 960, forecast: null, lower: null, upper: null },
      { month: 'May 25', actual: 774, forecast: null, lower: null, upper: null },
      { month: 'Jun 25', actual: 773, forecast: null, lower: null, upper: null },
      { month: 'Jul 25', actual: 752, forecast: null, lower: null, upper: null },
      { month: 'Aug 25', actual: 739, forecast: null, lower: null, upper: null },
      { month: 'Sep 25', actual: 679, forecast: null, lower: null, upper: null },
      { month: 'Oct 25', actual: 896, forecast: null, lower: null, upper: null },
      { month: 'Nov 25', actual: 657, forecast: null, lower: null, upper: null },
      { month: 'Dec 25', actual: 702, forecast: null, lower: null, upper: null },
      { month: 'Jan 26', actual: 760, forecast: null, lower: null, upper: null },
      { month: 'Feb 26', actual: 806, forecast: null, lower: null, upper: null },
      { month: 'Mar 26', actual: 867, forecast: null, lower: null, upper: null },
      { month: 'Apr 26', actual: 1076, forecast: null, lower: null, upper: null },
      { month: 'May 26', actual: 923, forecast: null, lower: null, upper: null },
      { month: 'Jun 26', actual: 903, forecast: 903, lower: 903, upper: 903 },
      { month: 'Jul 26', actual: null, forecast: 850, lower: 769, upper: 931 },
      { month: 'Aug 26', actual: null, forecast: 818, lower: 728, upper: 908 },
      { month: 'Sep 26', actual: null, forecast: 1036, lower: 906, upper: 1166 },
      { month: 'Oct 26', actual: null, forecast: 787, lower: 677, upper: 897 },
      { month: 'Nov 26', actual: null, forecast: 764, lower: 646, upper: 882 },
      { month: 'Dec 26', actual: null, forecast: 791, lower: 657, upper: 925 },
    ],
  },
  'RCE-CRM-80': {
    sku: 'RCE-CRM-80',
    name: 'Rice Ceramide Cream 80ml',
    unitPrice: 22,
    currentStock: 1301,
    daysCover: 96,
    status: 'OVERSTOCK',
    reorderQty: 0,
    nextMonthForecast: 345,
    mape: 9.8,
    yoyGrowth: 6.2,
    rows: [
      { month: 'Jul 24', actual: 270, forecast: null, lower: null, upper: null },
      { month: 'Aug 24', actual: 276, forecast: null, lower: null, upper: null },
      { month: 'Sep 24', actual: 279, forecast: null, lower: null, upper: null },
      { month: 'Oct 24', actual: 273, forecast: null, lower: null, upper: null },
      { month: 'Nov 24', actual: 313, forecast: null, lower: null, upper: null },
      { month: 'Dec 24', actual: 456, forecast: null, lower: null, upper: null },
      { month: 'Jan 25', actual: 347, forecast: null, lower: null, upper: null },
      { month: 'Feb 25', actual: 368, forecast: null, lower: null, upper: null },
      { month: 'Mar 25', actual: 374, forecast: null, lower: null, upper: null },
      { month: 'Apr 25', actual: 370, forecast: null, lower: null, upper: null },
      { month: 'May 25', actual: 327, forecast: null, lower: null, upper: null },
      { month: 'Jun 25', actual: 435, forecast: null, lower: null, upper: null },
      { month: 'Jul 25', actual: 295, forecast: null, lower: null, upper: null },
      { month: 'Aug 25', actual: 316, forecast: null, lower: null, upper: null },
      { month: 'Sep 25', actual: 326, forecast: null, lower: null, upper: null },
      { month: 'Oct 25', actual: 335, forecast: null, lower: null, upper: null },
      { month: 'Nov 25', actual: 355, forecast: null, lower: null, upper: null },
      { month: 'Dec 25', actual: 466, forecast: null, lower: null, upper: null },
      { month: 'Jan 26', actual: 377, forecast: null, lower: null, upper: null },
      { month: 'Feb 26', actual: 393, forecast: null, lower: null, upper: null },
      { month: 'Mar 26', actual: 413, forecast: null, lower: null, upper: null },
      { month: 'Apr 26', actual: 377, forecast: null, lower: null, upper: null },
      { month: 'May 26', actual: 381, forecast: null, lower: null, upper: null },
      { month: 'Jun 26', actual: 462, forecast: 462, lower: 462, upper: 462 },
      { month: 'Jul 26', actual: null, forecast: 345, lower: 312, upper: 378 },
      { month: 'Aug 26', actual: null, forecast: 345, lower: 307, upper: 383 },
      { month: 'Sep 26', actual: null, forecast: 362, lower: 317, upper: 407 },
      { month: 'Oct 26', actual: null, forecast: 374, lower: 322, upper: 426 },
      { month: 'Nov 26', actual: null, forecast: 492, lower: 416, upper: 568 },
      { month: 'Dec 26', actual: null, forecast: 420, lower: 349, upper: 491 },
    ],
  },
  'SPF-STK-19': {
    sku: 'SPF-STK-19',
    name: 'SPF50 Sun Stick 19g',
    unitPrice: 16,
    currentStock: 103,
    daysCover: 7,
    status: 'CRITICAL',
    reorderQty: 748,
    nextMonthForecast: 608,
    mape: 8.5,
    yoyGrowth: 12.3,
    rows: [
      { month: 'Jul 24', actual: 551, forecast: null, lower: null, upper: null },
      { month: 'Aug 24', actual: 591, forecast: null, lower: null, upper: null },
      { month: 'Sep 24', actual: 837, forecast: null, lower: null, upper: null },
      { month: 'Oct 24', actual: 740, forecast: null, lower: null, upper: null },
      { month: 'Nov 24', actual: 707, forecast: null, lower: null, upper: null },
      { month: 'Dec 24', actual: 634, forecast: null, lower: null, upper: null },
      { month: 'Jan 25', actual: 550, forecast: null, lower: null, upper: null },
      { month: 'Feb 25', actual: 452, forecast: null, lower: null, upper: null },
      { month: 'Mar 25', actual: 591, forecast: null, lower: null, upper: null },
      { month: 'Apr 25', actual: 401, forecast: null, lower: null, upper: null },
      { month: 'May 25', actual: 390, forecast: null, lower: null, upper: null },
      { month: 'Jun 25', actual: 439, forecast: null, lower: null, upper: null },
      { month: 'Jul 25', actual: 610, forecast: null, lower: null, upper: null },
      { month: 'Aug 25', actual: 693, forecast: null, lower: null, upper: null },
      { month: 'Sep 25', actual: 944, forecast: null, lower: null, upper: null },
      { month: 'Oct 25', actual: 725, forecast: null, lower: null, upper: null },
      { month: 'Nov 25', actual: 737, forecast: null, lower: null, upper: null },
      { month: 'Dec 25', actual: 692, forecast: null, lower: null, upper: null },
      { month: 'Jan 26', actual: 597, forecast: null, lower: null, upper: null },
      { month: 'Feb 26', actual: 511, forecast: null, lower: null, upper: null },
      { month: 'Mar 26', actual: 630, forecast: null, lower: null, upper: null },
      { month: 'Apr 26', actual: 414, forecast: null, lower: null, upper: null },
      { month: 'May 26', actual: 491, forecast: null, lower: null, upper: null },
      { month: 'Jun 26', actual: 493, forecast: 493, lower: 493, upper: 493 },
      { month: 'Jul 26', actual: null, forecast: 608, lower: 550, upper: 666 },
      { month: 'Aug 26', actual: null, forecast: 936, lower: 833, upper: 1039 },
      { month: 'Sep 26', actual: null, forecast: 777, lower: 680, upper: 874 },
      { month: 'Oct 26', actual: null, forecast: 851, lower: 732, upper: 970 },
      { month: 'Nov 26', actual: null, forecast: 787, lower: 665, upper: 909 },
      { month: 'Dec 26', actual: null, forecast: 738, lower: 613, upper: 863 },
    ],
  },
  'CTL-TNR-150': {
    sku: 'CTL-TNR-150',
    name: 'Centella Calming Toner 150ml',
    unitPrice: 19,
    currentStock: 1312,
    daysCover: 120,
    status: 'OVERSTOCK',
    reorderQty: 0,
    nextMonthForecast: 419,
    mape: 12.3,
    yoyGrowth: 12.4,
    rows: [
      { month: 'Jul 24', actual: 286, forecast: null, lower: null, upper: null },
      { month: 'Aug 24', actual: 292, forecast: null, lower: null, upper: null },
      { month: 'Sep 24', actual: 273, forecast: null, lower: null, upper: null },
      { month: 'Oct 24', actual: 261, forecast: null, lower: null, upper: null },
      { month: 'Nov 24', actual: 227, forecast: null, lower: null, upper: null },
      { month: 'Dec 24', actual: 231, forecast: null, lower: null, upper: null },
      { month: 'Jan 25', actual: 338, forecast: null, lower: null, upper: null },
      { month: 'Feb 25', actual: 253, forecast: null, lower: null, upper: null },
      { month: 'Mar 25', actual: 277, forecast: null, lower: null, upper: null },
      { month: 'Apr 25', actual: 278, forecast: null, lower: null, upper: null },
      { month: 'May 25', actual: 309, forecast: null, lower: null, upper: null },
      { month: 'Jun 25', actual: 307, forecast: null, lower: null, upper: null },
      { month: 'Jul 25', actual: 395, forecast: null, lower: null, upper: null },
      { month: 'Aug 25', actual: 284, forecast: null, lower: null, upper: null },
      { month: 'Sep 25', actual: 292, forecast: null, lower: null, upper: null },
      { month: 'Oct 25', actual: 272, forecast: null, lower: null, upper: null },
      { month: 'Nov 25', actual: 257, forecast: null, lower: null, upper: null },
      { month: 'Dec 25', actual: 247, forecast: null, lower: null, upper: null },
      { month: 'Jan 26', actual: 347, forecast: null, lower: null, upper: null },
      { month: 'Feb 26', actual: 268, forecast: null, lower: null, upper: null },
      { month: 'Mar 26', actual: 292, forecast: null, lower: null, upper: null },
      { month: 'Apr 26', actual: 327, forecast: null, lower: null, upper: null },
      { month: 'May 26', actual: 312, forecast: null, lower: null, upper: null },
      { month: 'Jun 26', actual: 345, forecast: 345, lower: 345, upper: 345 },
      { month: 'Jul 26', actual: null, forecast: 419, lower: 379, upper: 459 },
      { month: 'Aug 26', actual: null, forecast: 328, lower: 292, upper: 364 },
      { month: 'Sep 26', actual: null, forecast: 299, lower: 262, upper: 336 },
      { month: 'Oct 26', actual: null, forecast: 281, lower: 242, upper: 320 },
      { month: 'Nov 26', actual: null, forecast: 275, lower: 232, upper: 318 },
      { month: 'Dec 26', actual: null, forecast: 358, lower: 297, upper: 419 },
    ],
  },
};

export const promoCalendar = [
  {
    month: 'Nov 24',
    campaign: '11.11 Mega Sale',
    channel: 'Shopee / Lazada',
    liftPct: 42
  },
  {
    month: 'Dec 24',
    campaign: 'Year-End Gifting',
    channel: 'Instagram + TikTok Shop',
    liftPct: 28
  },
  {
    month: 'Feb 25',
    campaign: 'CNY Glow-Up',
    channel: 'Shopee / Lazada',
    liftPct: 35
  },
  {
    month: 'May 25',
    campaign: 'Summer Skin Prep',
    channel: 'TikTok Shop',
    liftPct: 22
  },
  {
    month: 'Aug 25',
    campaign: '8.8 Flash Sale',
    channel: 'Shopee / Lazada',
    liftPct: 31
  }
];

export const skuOrder = ['GLW-SER-30', 'SNL-MUC-50', 'RCE-CRM-80', 'SPF-STK-19', 'CTL-TNR-150'];
